import dex from './dex'
import points from './points'
import rebate from './rebate'
export default {
  home: {
    app: 'Memeshot',
    title: "Memeshot.com , that's the meme.",
    subTitle: '寻找一个meme币，下单，获得利润。就是这样。',
    inviteFriends: '加入社群，见证高手捕捉 ',
    inviteTextEnd: ' 倍涨幅 MEME 币!',
    appStore: 'App Store',
    testFlight: 'TestFlight',
    googlePlay: 'Google Play',
    android: 'Android',
    scanToDownload: '扫码下载',
    soon: '敬请期待',
    downloadFrom: '下载自',
    appDownload: '下载 Apk',
    joinUs: '加入我们',
    followUs: '关注我们',
    learn: '教程',
  },
  referralCenter: {
    inviteFriend: '邀请好友享 30% 手续费返佣',
    referralRules: '规则',
    totalReward: '我的总奖励',
    usdtAmount: '$', // USDT 直接用 $ 表示
    referralCount: '邀请人数',
    defaultReferral: '我的返佣',
    youReceive: '我的返佣比例',
    receiveAmount: '50%',
    referralLink: '邀请链接',
    inviteButton: '立即邀请',
    referralOverview: '邀请中心',
    totalReferralIncome: '总返佣收入($)', // USDT 直接用 $ 表示
    totalReferralCount: '累计邀请人数',
    myInvitations: '我的邀请',
    myRebates: '我的返佣',
    userId: '用户 ID',
    rebateRate: '返利比例',
    registrationTime: '注册时间',
    releaseTime: '发放时间',
    rebateAmount: '返佣', // USDT 直接用 $ 表示
    status: '状态',
    pendingRelease: '待发放',
    released: '已发放',
    copied: '复制成功',
    dataDetails: '详情',
    joinBtn: '商务合作',
    title1: '邀请普通社区成员 (R)',
    desc1: 'R 可获取直接邀请的普通社区成员 (R) 的 10%返佣',
    title2: '邀请黄金社区领导者 (G)',
    desc2: 'G 可获取直接邀请的银色社区领导者 (S)，普通社区成员 (R) 的 50%返佣',
    title3: '邀请银色社区领导者 (S)',
    desc3: 'S 可获取直接邀请的普通社区成员 (R) 的 40%返佣',
    invitation: '邀请',
    pageTitle: '邀请好友',
    pageSubtitle: '享**交易费返佣',
    invitationRelationship: '邀请关系',
    rebateRatio: '返佣比例',
    inviterID: '邀请人 ID',
    hash: '交易哈希',
    prePage: '上一页',
    nextPage: '下一页',
  },
  referralRulesTexts: {
    text0: '邀请等级：',
    text1: '黄金社区领导者 (G)',
    text2: '银色社区领导者 (S)',
    text3: '普通社区成员 (R)',
    text4: '返佣规则：',
    text5: '黄金社区领导者 (G):',
    text6: 'G可获得直接邀请的银色社区领导者 (S) 的40% 的交易手续费返佣。',
    text7: 'G可获得直接邀请的普通用户50%的交易手续费返佣。',
    text8: 'G可获得间接邀请的普通用户10%的交易手续费。',
    text9: '银色社区领导者 (S):',
    text10: 'S可获得直接邀请普通社区成员 (R) 40%的交易手续费返佣。',
    text11: '普通社区成员 (R):',
    text12: 'R可获得直接邀请普通社区成员（R）10%的交易手续费返佣。',
    text13: '如何获得等级：',
    textRoleTitle1: '黄金社区领导者 (G):',
    text14: "达到总佣金 $50,000 或通过'商务合作'申请获得该等级。",
    textRoleTitle2: '银色社区领导者 (S):',
    text15:
      '达到总佣金 $30,000 或申请此等级，或通过黄金社区领导者 (G) 的邀请链接注册。',
    textRole2Text: '',
    textRoleTitle3: '普通社区成员 (R):',
    text16:
      '直接注册，或被黄金社区领导者 (G)、银色社区领导者 (S) 或其他普通社区成员 (R) 邀请。',
    text17: '返佣方式：',
    text18: '返佣金额达到$5时进行结算。',
  },
  register: {
    title: '创建Memeshot账号',
    account: '账号',
    email: '邮箱',
    accountPlaceholder: '请输入邮箱',
    accountErrMsg: '请输入正确的邮箱',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    passwordErrMsg:
      '密码必须至少包含以下三个字符：小写、大写、数字或特殊字符。',
    signIn: '登录',
    signUp: '注册',
    verifyBtn: '获取验证码',
    verify: '验证码',
    verifyDesc: '请输入您在邮箱收到的6位验证码，10分钟有效',
    emailVerify: '邮箱验证码',
    emailVerifyPlaceholder: '请输入邮箱验证码',
    resend: '重新发送',
    confirm: '确认',
    confirmPassword: '确认密码',
    confirmPasswordErr: '两次密码输入不一致',
    inviteCode: '邀请码(选填)',
  },
  Cancellation: {
    logoffAccount: '注销账号申请',
    reason: '原因',
    reasonCancellation: '注销账号原因',
    applyInTitle: '审核中，感谢支持',
    applyDoneText: '注销成功了',
    cancelApplyButton: '取消注销',
    submit: '提交',
    cancelApply: '取消申请',
  },
  // 目前只支持英文版
  userAgreement: {
    welcome: 'Thank you for using Memeshot!',
    policyMainText:
      'This Privacy Policy details how we collect, use, disclose, and protect your personal information to ensure your privacy rights. We are committed to complying with data privacy laws and regulations and safeguarding the security of your personal information.',
    part1: '1. Protection of Information',
    part1Text:
      'In the course of using this application, we may protect information including but not limited to the following types:',
    part1_1: '1.1 User Identity Information',
    part1_1Text:
      '- Wallet Address: The blockchain wallet address you create or connect to this application. We do not collect your real identity information.',
    part1_1Text2:
      '- Transaction Records: Necessary on-chain transaction records used to provide services, which do not include any unnecessary personal identification information.',
    part1_2: '1.2 Usage Information',
    part1_2Text:
      '- Application Usage Data: We automatically collect your interaction data with this application, such as page visits, clicks, and browsing behavior, to help us optimize application features and user experience.',
    part1_3: '1.3 Device Information',
    part1_3Text:
      "- Device Identifiers and Operating System: Includes the device's operating system version and unique device identifier, used to ensure the normal operation and security of the application.",
    part2: '2. Use of Information',
    part2Text:
      'We strictly use your information in a legal, proper, and necessary manner in accordance with this Privacy Policy and relevant laws and regulations. The specific purposes are as follows:',
    part2_1:
      '- Providing and Maintaining Services: Processing on-chain transactions to ensure the normal operation of the custodial wallet.',
    part2_2:
      '- Improving User Experience: Continuously optimizing product features and user interfaces by analyzing application usage behaviors.',
    part2_3:
      '- Ensuring Security: Detecting, preventing, and resolving fraud and illegal activities to protect the security of your assets.',
    part3: '3. Sharing of Information',
    part3Text:
      'We do not sell, rent, or share your personal information with any third parties, but we may share your information under the following circumstances:',
    part3_1:
      'Third-Party Service Providers: To provide application functionalities, we may need to share necessary information with trusted third-party partners. These third parties are limited to using your information only within the scope required to provide their services.',
    part3_2:
      'Legal Requirements: Your information may need to be disclosed if required by laws, legal processes, or government requests.',
    part4: '4. Security of Information',
    part4Text:
      'We are committed to protecting the security of your personal information and have implemented reasonable technical and managerial measures to prevent unauthorized access, disclosure, alteration, or destruction of your information. However, the network environment is not 100% secure, so please properly safeguard your wallet keys and other sensitive information.',
    part5: '5. Privacy Protection for Minors',
    part5Text:
      'This application is not intended for minors. If we discover that we have collected personal information from minors, we will take steps to delete the relevant data as soon as possible.',
    part6: '6. Your Rights',
    part6Text:
      'Under applicable data protection laws, you have the right to perform the following actions regarding your information:',
    part6_1:
      'Access, Update, and Deletion: You can access, update, or delete your account information.',
    part6_2:
      'Privacy Settings: You can adjust your privacy settings within the application at any time to manage how your information is collected and used.',
    part7: '7. Changes to the Privacy Policy',
    part7Text:
      'We may update this Privacy Policy from time to time. The updated Privacy Policy will be posted on this page with the effective date indicated. We recommend that you regularly review the Privacy Policy to stay informed about our latest privacy protection measures.',
  },
  dex: dex.zh_CN,
  points: points.zh_CN,
  rebate: rebate.zh_CN
}
